import { render, staticRenderFns } from "./AlertList.vue?vue&type=template&id=6740c3b2&scoped=true"
import script from "./AlertList.vue?vue&type=script&lang=js"
export * from "./AlertList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740c3b2",
  null
  
)

export default component.exports